import React, { useContext } from "react";
import { Honeybadger } from '@honeybadger-io/react'
import { useMutation } from "@apollo/client";

import { ToolContext, RECEIPT_STEP, PAYMENT_STEP } from "./ToolProvider";
import useFingerprint from "../../lib/useFingerprint";
import { trackDonationBegan } from "./utils";
import { setupPaymentIntentMutation } from "./mutations";
import ExpressCheckout from "./ExpressCheckout";
import Layout from "../Layout";
import DonorForm from "./DonorForm";

import * as UI from "./ui";

const ERROR = "Uh-oh! Sorry, but something has gone wrong. To try again please submit the form again. We’ve notified our support team of this issue.";

const notifyFailure = (error) => {
  Honeybadger.notify(error);
}

const WalletOrCardStep = ({ setErrorMessage, setDonationLevelError, sweepstakes, disabled, setDonationInProgress }) => {
  const { donationLevel, promoCode, paymentIntent, setPaymentIntent, setStep } = useContext(ToolContext);
  const fingerprint = useFingerprint();
  const [ setupPaymentIntent, { loading }] = useMutation(setupPaymentIntentMutation);

  const saveDonation = () => {
    setErrorMessage('');
    setDonationLevelError('');

    if(!donationLevel) {
      setDonationLevelError("Please select an amount before continuing.");
      return;
    }

    setupPaymentIntent({
      variables: {
        attributes: {
          id: paymentIntent && paymentIntent.id,
          donationLevelId: donationLevel.id,
          promoCodeName: promoCode && promoCode.name,
          fingerprint,
        }
      }
    }).then(({data: { setupPaymentIntent: { paymentIntent, error }}}) => {
      if(paymentIntent) {
        trackDonationBegan({ sweepstakes, donationLevel, promoCode, paymentIntent });
        setPaymentIntent(paymentIntent);
        setStep(PAYMENT_STEP);
      } else {
        notifyFailure(error.message);
        setErrorMessage(ERROR);
      }
    }).catch((error) => {
        notifyFailure(error.message);
        setErrorMessage(ERROR);
    });
  };

  return (
    <Layout.FlexibleColumn span={[7,17]} breakpoint="belowLaptop">
      <ExpressCheckout
        onComplete={() => setStep(RECEIPT_STEP)}
        sweepstakes={sweepstakes}
        fingerprint={fingerprint}
        setDonationInProgress={setDonationInProgress}
        setupPaymentIntent={setupPaymentIntent}
        setErrorMessage={setErrorMessage}
        disabled={loading || disabled}
      />
      <UI.SubstepHeading>Proceed with a Card</UI.SubstepHeading>
      <DonorForm onComplete={saveDonation} disabled={loading || disabled} />
    </Layout.FlexibleColumn>
  );
};

export default WalletOrCardStep;
